/**
 * DevExtreme (esm/ui/date_box/ui.date_box.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../core/component_registrator";
import DateBoxMask from "./ui.date_box.mask";
registerComponent("dxDateBox", DateBoxMask);
export default DateBoxMask;
